$mol_plot_pane $mol_svg_root
	aspect \none
	-
	hue_base? +NaN
	hue_shift? 111
	-
	gap_hor 48
	gap_vert 24
	gap_left <= gap_hor
	gap_right <= gap_hor
	gap_top <= gap_vert
	gap_bottom <= gap_vert
	gap $mol_vector_2d<$mol_vector_range<number>> /
		<= gap_x $mol_vector_range<number> /
			<= gap_left
			<= gap_right
		<= gap_y $mol_vector_range<number> /
			<= gap_bottom
			<= gap_top
	-
	shift_limit $mol_vector_2d<$mol_vector_range<number>> /
		<= shift_limit_x $mol_vector_range<number> /
			0
			0
		<= shift_limit_y $mol_vector_range<number> /
			0
			0
	shift_default $mol_vector_2d<number> /
		0
		0
	shift? $mol_vector_2d<number> /
		0
		0
	scale_limit $mol_vector_2d<$mol_vector_range<number>> /
		<= scale_limit_x $mol_vector_range<number> /
			0
			Infinity
		<= scale_limit_y $mol_vector_range<number> /
			0
			-Infinity
	scale_default $mol_vector_2d<number> /
		0
		0
	scale? $mol_vector_2d<number> /
		1
		-1
	scale_x? 1
	scale_y? -1
	size $mol_vector_2d<number> /
		0
		0
	size_real $mol_vector_2d<number> /
		1
		1
	dimensions $mol_vector_2d<$mol_vector_range<number>> /
		<= dimensions_x $mol_vector_range<number> /
			Infinity
			-Infinity
		<= dimensions_y $mol_vector_range<number> /
			Infinity
			-Infinity
	dimensions_viewport $mol_vector_2d<$mol_vector_range<number>> /
		<= dimensions_viewport_x $mol_vector_range<number> /
			Infinity
			-Infinity
		<= dimensions_viewport_y $mol_vector_range<number> /
			Infinity
			-Infinity
	-
	sub <= graphs_sorted /$mol_svg
	graphs_colored <= graphs_visible <= graphs_positioned <= graphs /$mol_plot_graph
	-
	plugins /
		^
		<= Touch $mol_touch
			zoom? <=> zoom? 1
			pan? <=> shift?
			pointer_center => cursor_position
			allow_draw <= allow_draw true
			allow_pan <= allow_pan true
			allow_zoom <= allow_zoom true
			action_type => action_type
			action_point => action_point
			draw_start?event <=> draw_start?event null
			draw?event <=> draw?event null
			draw_end?event <=> draw_end?event null
	- event *
		^
		dblclick?event <=> reset?event null
